import React from 'react';
import SidebarMenu from './SidebarMenu/SidebarMenu';
import { BreadcrumbsProvider } from '../context/BreadcrumbsContext';
import useRouteChange from '../hooks/useRouteChange';

const Layout = ({ children }) => {
  // Utiliser le hook pour écouter les changements de route
  useRouteChange();

  return (
    <BreadcrumbsProvider>
      <div className="flex min-h-screen overflow-x-hidden">
        <SidebarMenu />
        <main className={`flex-1 ml-[75px] transition-all duration-300 max-w-[calc(100vw-75px)]`}>
          {children}
        </main>
      </div>
    </BreadcrumbsProvider>
  );
};

export default Layout;
